"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullWeb3Provider = void 0;
var core_1 = require("@web3-react/core");
var react_1 = __importDefault(require("react"));
var web3_1 = __importDefault(require("web3"));
var index_1 = require("../../../shared/hooks/useWeb3/index");
function getLibrary(provider) {
    return new web3_1.default(provider);
}
/**
 * Web3React + our custom web3
 */
function FullWeb3Provider(_a) {
    var chain = _a.chain, children = _a.children, useUserConnectionByDefault = _a.useUserConnectionByDefault;
    return (react_1.default.createElement(core_1.Web3ReactProvider, { getLibrary: getLibrary },
        react_1.default.createElement(index_1.Web3Provider, { chain: chain, useUserConnectionByDefault: useUserConnectionByDefault }, children)));
}
exports.FullWeb3Provider = FullWeb3Provider;
